import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { Product } from 'src/app/modals/product.model';

@Component({
  selector: 'app-product-vertical',
  templateUrl: './product-vertical.component.html',
  styleUrls: ['./product-vertical.component.scss']
})
export class ProductVerticalComponent implements OnInit {
  contentLoaded = false;
  productsNovi: Product[];
  productsTop:Product[];
 @Input() products: Product[];

  constructor(private productService: ProductService ) { }
  getProductImageUrl(product: any): string {
    // Check if product.pictures[0] exists and is not empty
    if (product.pictures && product.pictures[0]) {
      return `https://weberp-api.com/images/${product.pictures[0]}`;
    } else {
      return '/assets/images/noimg.jpg';
    }
  }
  ngOnInit() {
    this.productService.getProducts().subscribe((product) => {
      this.products = product.filter(p=>p.price > 0);
    });
    this.productService.getTopProducts().subscribe((product) => {
      this.productsTop =  product.filter(p=>p.price > 0);
    });
    this.productService.getNoviProducts().subscribe((product) => {
      this.productsNovi =  product.filter(p=>p.price > 0);
    });

    setTimeout(() => {
      this.contentLoaded = true;
    }, 3000);
  }

}
